// Muss bytegleich mit `canonical_message` in stempel-api (services/device_auth.rs) sein --
// sonst schlaegt die serverseitige Signaturpruefung fehl, auch mit korrektem Schluessel.
//
// client_time.toISOString() liefert IMMER "YYYY-MM-DDTHH:mm:ss.sssZ" (exakt 3 Nachkomma-
// stellen, "Z"-Suffix) -- das entspricht auf der Rust-Seite bewusst
// `to_rfc3339_opts(SecondsFormat::Millis, true)`, NICHT dem `to_rfc3339()`-Default (der
// haette je nach Praezision eine andere Anzahl Nachkommastellen + "+00:00" statt "Z").

// ANFAHRT/ABFAHRT: Fahrtzeit als eigene Stempel-Ereignisse (TQ #18899/#18900,
// Patric-Entscheid 07.09.2026) -- muss exakt zu LogType in stempel-api
// (services/models/checkin.rs) passen.
export type LogType = 'IN' | 'OUT' | 'ANFAHRT' | 'ABFAHRT'

export interface CheckinFields {
  eventId: string
  deviceId: string
  employeeIdentifier: string
  logType: LogType
  clientTime: Date
  monotonicCounter: number
  // Rapport-Digitalisierung (TQ #18899/#18900). Fehlend -> leerer String, NICHT weggelassen
  // (feste Anzahl Trennzeichen unabhaengig vom Auftragsbezug) -- muss exakt zu
  // canonical_message() in stempel-api (services/device_auth.rs) passen. Sicherheitsreview-
  // Fund vor dem Merge: diese Felder MUESSEN signiert werden, sonst koennte ein Angreifer
  // zwischen PWA und Server sie unbemerkt aendern.
  auftragId?: string
  taetigkeitGeplant?: string
  taetigkeitIst?: string
  // Zusatzgeraet/Anbauteil (Patric-Entscheid 07.09.2026: pro Tag/Zeile, Freitext).
  // Feld 10 in der canonical_message-Sequenz.
  zusatzgeraet?: string
}

export function canonicalMessage(fields: CheckinFields): string {
  return [
    fields.eventId,
    fields.deviceId,
    fields.employeeIdentifier,
    fields.logType,
    fields.clientTime.toISOString(),
    String(fields.monotonicCounter),
    fields.auftragId ?? '',
    fields.taetigkeitGeplant ?? '',
    fields.taetigkeitIst ?? '',
    fields.zusatzgeraet ?? '',
  ].join('\n')
}
